// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { DBBaseElement } from './DBBaseElement';
import { BEEntity } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { DBComponent } from './DBComponent';
import { DBColumn } from './DBColumn';
import { ForeignKey } from './ForeignKey';
import { PrimaryKey } from './PrimaryKey';
import { IndexConstraint } from './IndexConstraint';
import { DefaultConstaint } from './DefaultConstaint';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 数据库表 实体类
 * 数据库表
 */
export class DBTable extends DBBaseElement {
  /** 绑定实体 的ID */
  private _bindingBEEntity_ID: string;

  /** 获取：绑定实体 的ID */
  public get bindingBEEntity_ID() {
    return this._bindingBEEntity_ID;
  }

  /** 设置：绑定实体 的ID */
  public set bindingBEEntity_ID(value: string) {
    this._bindingBEEntity_ID = value;
  }

  /** 绑定实体  */
  private _bindingBEEntity: BEEntity;

  /** 获取：绑定实体  */
  public get bindingBEEntity() {
    return this._bindingBEEntity;
  }

  /** 设置：绑定实体  */
  public set bindingBEEntity(value: BEEntity) {
    this._bindingBEEntity = value;
    if (value !== null) {
      this.bindingBEEntity_ID = value.id;
    } else {
      this.bindingBEEntity_ID = '';
    }
  }

  /** 绑定源实体 的ID */
  private _bindingSourceEntity_ID: string;

  /** 获取：绑定源实体 的ID */
  public get bindingSourceEntity_ID() {
    return this._bindingSourceEntity_ID;
  }

  /** 设置：绑定源实体 的ID */
  public set bindingSourceEntity_ID(value: string) {
    this._bindingSourceEntity_ID = value;
  }

  /** 绑定源实体  */
  private _bindingSourceEntity: BEEntity;

  /** 获取：绑定源实体  */
  public get bindingSourceEntity() {
    return this._bindingSourceEntity;
  }

  /** 设置：绑定源实体  */
  public set bindingSourceEntity(value: BEEntity) {
    this._bindingSourceEntity = value;
    if (value !== null) {
      this.bindingSourceEntity_ID = value.id;
    } else {
      this.bindingSourceEntity_ID = '';
    }
  }

  /** 绑定目标实体 的ID */
  private _bindingTargetEntity_ID: string;

  /** 获取：绑定目标实体 的ID */
  public get bindingTargetEntity_ID() {
    return this._bindingTargetEntity_ID;
  }

  /** 设置：绑定目标实体 的ID */
  public set bindingTargetEntity_ID(value: string) {
    this._bindingTargetEntity_ID = value;
  }

  /** 绑定目标实体  */
  private _bindingTargetEntity: BEEntity;

  /** 获取：绑定目标实体  */
  public get bindingTargetEntity() {
    return this._bindingTargetEntity;
  }

  /** 设置：绑定目标实体  */
  public set bindingTargetEntity(value: BEEntity) {
    this._bindingTargetEntity = value;
    if (value !== null) {
      this.bindingTargetEntity_ID = value.id;
    } else {
      this.bindingTargetEntity_ID = '';
    }
  }

  /** 数据库组件 的ID */
  private _component_ID: string;

  /** 获取：数据库组件 的ID */
  public get component_ID() {
    return this._component_ID;
  }

  /** 设置：数据库组件 的ID */
  public set component_ID(value: string) {
    this._component_ID = value;
  }

  /** 数据库组件  */
  private _component: DBComponent;

  /** 获取：数据库组件  */
  public get component() {
    return this._component;
  }

  /** 设置：数据库组件  */
  public set component(value: DBComponent) {
    this._component = value;
    if (value !== null) {
      this.component_ID = value.id;
    } else {
      this.component_ID = '';
    }
  }

  /** 数据库列 */
  private _columns: Array<DBColumn>;

  /** 获取：数据库列 */
  public get columns() {
    return this._columns;
  }

  /** 设置：数据库列 */
  public set columns(value: Array<DBColumn>) {
    this._columns = value;
  }

  /** 外键 */
  private _foreignKeys: Array<ForeignKey>;

  /** 获取：外键 */
  public get foreignKeys() {
    return this._foreignKeys;
  }

  /** 设置：外键 */
  public set foreignKeys(value: Array<ForeignKey>) {
    this._foreignKeys = value;
  }

  /** 主键 */
  private _primaryKeys: Array<PrimaryKey>;

  /** 获取：主键 */
  public get primaryKeys() {
    return this._primaryKeys;
  }

  /** 设置：主键 */
  public set primaryKeys(value: Array<PrimaryKey>) {
    this._primaryKeys = value;
  }

  /** 索引 */
  private _indexConstraints: Array<IndexConstraint>;

  /** 获取：索引 */
  public get indexConstraints() {
    return this._indexConstraints;
  }

  /** 设置：索引 */
  public set indexConstraints(value: Array<IndexConstraint>) {
    this._indexConstraints = value;
  }

  /** 缺省值约束 */
  private _defaultConstaints: Array<DefaultConstaint>;

  /** 获取：缺省值约束 */
  public get defaultConstaints() {
    return this._defaultConstaints;
  }

  /** 设置：缺省值约束 */
  public set defaultConstaints(value: Array<DefaultConstaint>) {
    this._defaultConstaints = value;
  }

  constructor() {
    super();
    this._bindingBEEntity_ID = '';
    this._bindingBEEntity = null;
    this._bindingSourceEntity_ID = '';
    this._bindingSourceEntity = null;
    this._bindingTargetEntity_ID = '';
    this._bindingTargetEntity = null;
    this._component_ID = '';
    this._component = null;
    this._columns = new Array<DBColumn>();
    this._foreignKeys = new Array<ForeignKey>();
    this._primaryKeys = new Array<PrimaryKey>();
    this._indexConstraints = new Array<IndexConstraint>();
    this._defaultConstaints = new Array<DefaultConstaint>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: DBTable, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.bindingBEEntity_ID = element.bindingBEEntity_ID;
      if (hasReference && element.bindingBEEntity !== null) {
        this.bindingBEEntity = element.bindingBEEntity;
      }
      this.bindingSourceEntity_ID = element.bindingSourceEntity_ID;
      if (hasReference && element.bindingSourceEntity !== null) {
        this.bindingSourceEntity = element.bindingSourceEntity;
      }
      this.bindingTargetEntity_ID = element.bindingTargetEntity_ID;
      if (hasReference && element.bindingTargetEntity !== null) {
        this.bindingTargetEntity = element.bindingTargetEntity;
      }
      this.component_ID = element.component_ID;
      if (hasReference && element.component !== null) {
        this.component = element.component;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.bindingBEEntity_ID = json.BindingBEEntity_ID;
    // if (json.BindingBEEntity !== null) {
    //   this.bindingBEEntity = BEEntity.Create(json.BindingBEEntity);
    // }
    this.bindingSourceEntity_ID = json.BindingSourceEntity_ID;
    // if (json.BindingSourceEntity !== null) {
    //   this.bindingSourceEntity = BEEntity.Create(json.BindingSourceEntity);
    // }
    this.bindingTargetEntity_ID = json.BindingTargetEntity_ID;
    // if (json.BindingTargetEntity !== null) {
    //   this.bindingTargetEntity = BEEntity.Create(json.BindingTargetEntity);
    // }
    this.component_ID = json.Component_ID;
    // if (json.Component !== null) {
    //   this.component = DBComponent.Create(json.Component);
    // }
    if (json.Columns && json.Columns.length > 0) {
      json.Columns.forEach((element: any) => {
        const dBColumn = DBColumn.Create(element);
        // dBColumn.table = this;
        this.columns.push(dBColumn);
      });
    }
    if (json.ForeignKeys && json.ForeignKeys.length > 0) {
      json.ForeignKeys.forEach((element: any) => {
        const foreignKey = ForeignKey.Create(element);
        // foreignKey.table = this;
        this.foreignKeys.push(foreignKey);
      });
    }
    if (json.PrimaryKeys && json.PrimaryKeys.length > 0) {
      json.PrimaryKeys.forEach((element: any) => {
        const primaryKey = PrimaryKey.Create(element);
        // primaryKey.table = this;
        this.primaryKeys.push(primaryKey);
      });
    }
    if (json.IndexConstraints && json.IndexConstraints.length > 0) {
      json.IndexConstraints.forEach((element: any) => {
        const indexConstraint = IndexConstraint.Create(element);
        // indexConstraint.table = this;
        this.indexConstraints.push(indexConstraint);
      });
    }
    if (json.DefaultConstaints && json.DefaultConstaints.length > 0) {
      json.DefaultConstaints.forEach((element: any) => {
        const defaultConstaint = DefaultConstaint.Create(element);
        // defaultConstaint.table = this;
        this.defaultConstaints.push(defaultConstaint);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.BindingBEEntity_ID = this.bindingBEEntity_ID;
    json.BindingSourceEntity_ID = this.bindingSourceEntity_ID;
    json.BindingTargetEntity_ID = this.bindingTargetEntity_ID;
    json.Component_ID = this.component_ID;
    if (this.columns && this.columns.length > 0) {
      json.Columns = [];
      this.columns.forEach((element) => {
        json.Columns.push(element.toJson());
      });
    }
    if (this.foreignKeys && this.foreignKeys.length > 0) {
      json.ForeignKeys = [];
      this.foreignKeys.forEach((element) => {
        json.ForeignKeys.push(element.toJson());
      });
    }
    if (this.primaryKeys && this.primaryKeys.length > 0) {
      json.PrimaryKeys = [];
      this.primaryKeys.forEach((element) => {
        json.PrimaryKeys.push(element.toJson());
      });
    }
    if (this.indexConstraints && this.indexConstraints.length > 0) {
      json.IndexConstraints = [];
      this.indexConstraints.forEach((element) => {
        json.IndexConstraints.push(element.toJson());
      });
    }
    if (this.defaultConstaints && this.defaultConstaints.length > 0) {
      json.DefaultConstaints = [];
      this.defaultConstaints.forEach((element) => {
        json.DefaultConstaints.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'bindingBEEntity', '绑定实体', EnumDataType.Reference, this.bindingBEEntity, true, '绑定实体，对应实体表有效', 'BEEntity', '');
    context.addRow('基本属性', 'bindingSourceEntity', '绑定源实体', EnumDataType.Reference, this.bindingSourceEntity, true, '绑定源实体，对于交叉表有效', 'BEEntity', '');
    context.addRow('基本属性', 'bindingTargetEntity', '绑定目标实体', EnumDataType.Reference, this.bindingTargetEntity, true, '绑定目标实体，对于交叉表有效', 'BEEntity', '');
    return context;
  }

  static Create(json: any): DBTable {
    const dBTable = new DBTable();
    dBTable.Deserialize(json);
    dBTable.json = json;
    return dBTable;
  }
}
